// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/user/routes/ChangePassword/components/ChangePassword/ChangePassword.scss
// module id = 820
// module chunks = 0